<script setup>
import { ref } from 'vue';
import Spinner from '@components/Spinner.vue';
import MediaImage from '@components/MediaImage.vue';
import { useAddressStore } from '@stores/useAddressStore';

const store = useAddressStore();

const props = defineProps({
  image: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  over: {
    type: Boolean,
    required: true,
  },
  dragStartedIndex: {
    type: Boolean,
    required: true,
  },
});

const showDragButton = ref(false);

const emit = defineEmits([ 'drag-start', 'drag-enter', 'drag-end' ]);

const handleDragStart = () => emit('drag-start', props.index);
const handleDragEnter = () => emit('drag-enter', props.index);
const handleDragEnd = () => emit('drag-end', props.index);
</script>

<template>
  <div
    class="card card-image"
    :class="{
      'drag-start': props.dragStartedIndex,
      'drag-overlay': props.over && !props.dragStartedIndex
    }"
    :draggable="showDragButton"
    @dragstart="handleDragStart"
    @dragenter="handleDragEnter"
    @dragend="handleDragEnd"
    @dragover.prevent=""
    @dragleave.prevent=""
    @mouseover="showDragButton = true"
    @mouseleave="showDragButton = false"
  >
    <div
      v-show="!props.over || props.dragStartedIndex"
      class="card-image__content"
    >
      <div v-show="image.uploading" class="card-image__loader">
        <Spinner :size="44" />
      </div>

      <a
        v-show="showDragButton"
        class="card-image__button card-image__button--drag"
        @click.prevent=""
      />

      <img v-if="image.src" :src="image.src" class="card-image__picture" draggable="false">

      <MediaImage
        v-else
        :uuid="image.uuid"
        picture-class="card-image__picture"
        :height="750"
        :ratio="[ 3, 2 ]"
        :media="{
          1000: { height: 120 },
        }"
        :draggable="false"
      />

      <button
        v-show="!image.uploading"
        class="card-image__button card-image__button--delete"
        @click="store.deleteMedia(props.index)"
      />
    </div>
  </div>
</template>
